import { BaseRouteService } from 'core/services';

class FulfillmentOrderRouteService extends BaseRouteService {
	constructor() {
		super();
		this.base = 'fulfillment-orders/';
	}

	get(id, options) {
		return super.get(this.base + '{id}/{?embed}', id, options);
	}

	select(filter) {
		return super.create(this.base + 'select', filter);
	}

	update(resource, sourceOfChange) {
		return super.update(this.base + '{id}/?sourceOfChange={sourceOfChange}', resource, { sourceOfChange });
	}

	find(filter) {
		return super.create(this.base + 'search', filter);
	}

	getFulfillmentOrdersForLabeling(filter) {
		return super.create(this.base + 'get-fulfillment-orders-for-labeling', filter);
	}

	getCloseoutOrders(filter) {
		return super.create(this.base + 'get-closeout-orders', filter);
	}

	splitFulfillmentOrder = sourceOfChange => {
		return this.uriTemplateService
			.parse(`${this.base}split-fulfillment-order?sourceOfChange={sourceOfChange}`)
			.expand({ sourceOfChange });
	};

	editFulfillmentOrderSplit = sourceOfChange => {
		return this.uriTemplateService
			.parse(`${this.base}edit-fulfillment-order-split?sourceOfChange={sourceOfChange}`)
			.expand({ sourceOfChange });
	};

	getFulfillmentOrderShipment(upc, sourceOfChange) {
		return super.get(this.base + 'get-fulfillment-order-shipment/{id}/?sourceOfChange={sourceOfChange}', upc, {
			sourceOfChange,
		});
	}

	toggleProductionMode(id, productionMode, sourceOfChange) {
		return super.update(
			this.base + 'production-mode/?id={id}&productionMode={productionMode}&sourceOfChange={sourceOfChange}',
			null,
			{ id, productionMode, sourceOfChange }
		);
	}

	syncOrdersByChannel(channelId) {
		return super.get(this.base + 'sync/{id}', channelId);
	}

	changeShipping(changeShippingParams, sourceOfChange) {
		return super.get(this.base + 'change-shipping/?sourceOfChange={sourceOfChange}', changeShippingParams, {
			sourceOfChange,
		});
	}

	changeShippingBulk(changeShippingBulkParams, sourceOfChange) {
		return super.get(this.base + 'change-shipping-bulk/?sourceOfChange={sourceOfChange}', changeShippingBulkParams, {
			sourceOfChange,
		});
	}

	syncOrders() {
		return super.get(this.base + 'sync');
	}

	countFulfillmentOrdersByStatus(filter) {
		return super.create(this.base + 'count', filter);
	}

	updateBuyShippingBulk(items, sourceOfChange) {
		return super.get(this.base + 'update-buyshipping-bulk/?sourceOfChange={sourceOfChange}', items, { sourceOfChange });
	}

	assignCarrierServiceAndWarehouse(data, sourceOfChange) {
		return super.update(this.base + 'assign/?sourceOfChange={sourceOfChange}', data, { sourceOfChange });
	}

	assignCarrierServiceAndWarehouseBulk(data, sourceOfChange) {
		return super.update(this.base + 'assign-bulk/?sourceOfChange={sourceOfChange}', data, { sourceOfChange });
	}

	collectFulfillmentOrdermItem(item) {
		return super.update(this.base + 'collect/id={id}&upc={upc}', item);
	}

	scanLabel(resource, sourceOfChange) {
		return super.update(this.base + 'scan-label/{id}/?sourceOfChange={sourceOfChange}', resource, { sourceOfChange });
	}

	cancelFulfillmentOrder(resource, sourceOfChange) {
		return super.update(this.base + 'cancel/{id}/?sourceOfChange={sourceOfChange}', resource, { sourceOfChange });
	}

	neverShipped(neverShippedParams, sourceOfChange) {
		return super.get(this.base + 'never-shipped/?sourceOfChange={sourceOfChange}', neverShippedParams, {
			sourceOfChange,
		});
	}

	neverShippedBulk(neverShippedBulkParams, voidOnChannel, sourceOfChange) {
		return super.update(
			this.base + 'never-shipped-bulk/?voidOnChannel = {voidOnChannel}&sourceOfChange={sourceOfChange}',
			neverShippedBulkParams,
			{ voidOnChannel, sourceOfChange }
		);
	}

	statusChange(statusChangeParams, sourceOfChange) {
		return super.update(this.base + 'status-change/?sourceOfChange={sourceOfChange}', statusChangeParams, {
			sourceOfChange,
		});
	}

	onHold(onHoldParams, sourceOfChange) {
		return super.update(this.base + 'on-hold/?sourceOfChange={sourceOfChange}', onHoldParams, { sourceOfChange });
	}

	onHoldBulk(onHoldBulkParams, sourceOfChange) {
		return super.update(this.base + 'on-hold-bulk/?sourceOfChange={sourceOfChange}', onHoldBulkParams, {
			sourceOfChange,
		});
	}

	markAsShipped(markAsShippedParams, sourceOfChange) {
		return super.update(this.base + 'mark-as-shipped/?sourceOfChange={sourceOfChange}', markAsShippedParams, {
			sourceOfChange,
		});
	}

	markAsShippedBulk(markAsShippedBulkParams, sourceOfChange) {
		return super.update(this.base + 'mark-as-shipped-bulk/?sourceOfChange={sourceOfChange}', markAsShippedBulkParams, {
			sourceOfChange,
		});
	}

	undoPackaged(undoPackageParams, sourceOfChange) {
		return super.update(this.base + 'undo-package/?sourceOfChange={sourceOfChange}', undoPackageParams, {
			sourceOfChange,
		});
	}

	track(trackingParams) {
		return super.create(this.base + 'track', trackingParams);
	}

	abortLabelingMode(abortLabelingParams, sourceOfChange) {
		return super.update(this.base + 'abort-labeling/?sourceOfChange={sourceOfChange}', abortLabelingParams, {
			sourceOfChange,
		});
	}

	createWarehouseOrders(fulfillmentOrderIds) {
		return super.create(this.base + 'create-warehouse-orders', fulfillmentOrderIds);
	}

	splitFulfillmentOrderLabelingMode(splitFulfillmentOrderParams, sourceOfChange) {
		return super.create(
			this.base + 'split-fulfillment-order-labeling-mode/?sourceOfChange={sourceOfChange}',
			splitFulfillmentOrderParams,
			{ sourceOfChange }
		);
	}

	updateFulfillmentOrderInfo(resource, sourceOfChange) {
		return super.update(this.base + 'update-fulfillment-order-info/?sourceOfChange={sourceOfChange}', resource, {
			sourceOfChange,
		});
	}

	validateOrderAddress(resource) {
		return super.update(this.base + 'verify-fulfillment-order-address', resource);
	}

	reoptimize(sourceOfChange) {
		return super.update(this.base + 'reoptimize/?sourceOfChange={sourceOfChange}', { sourceOfChange });
	}
}

export default FulfillmentOrderRouteService;



// WEBPACK FOOTER //
// ./src/common/data/route-services/FulfillmentOrderRouteService.js